import { getToken, setToken } from "@/utils/token";
import {
    SET_TOKEN,
    setTokenActionCreator,
    UserAction,
    setUserInfoActionCreator,
} from "@/redux/user/userReducerAction";
import { ThunkAction } from "redux-thunk";
import { RootState } from "@/redux";
import { User } from "@/types";
import { getUserInfo } from "@/api";
import { SET_USER_INFO } from "./userReducerAction";

interface UserState {
    token: string | null;
    userInfo: User | null;
}
const defaultState: UserState = {
    token: getToken(),
    userInfo: null,
};
export default (state = defaultState, action: UserAction) => {
    switch (action.type) {
        case SET_TOKEN:
            return { ...state, token: action.payload };
        case SET_USER_INFO:
            return { ...state, userInfo: action.payload };
        default:
            return state;
    }
};
export const setTokenAction =
    (token: string): ThunkAction<any, RootState, unknown, UserAction> =>
    dispatch => {
        setToken(token);
        dispatch(setTokenActionCreator(token));
    };

export const getUserAction =
    (): ThunkAction<any, RootState, unknown, UserAction> => async dispatch => {
        // const res = await getUserInfo();
        const res: User = {
            id: 0,
            username: "admin",
            nickname: "超级管理员",
            phone: "",
            avatar: "",
            dataStatus: 1,
            createTime: "",
            updateTime: "",
            dept: {
                id: 1,
                name: "管理层",
                parentId: 0,
                sort: 0,
                ancestors: "",
                dataStatus: 1,
                createTime: "",
                updateTime: "",
            },
            role:
                {
                    id: 1,
                    roleName: "admin",
                    roleDesc: "超级管理员",
                    dataStatus: true,
                    createTime: "",
                    updateTime: "",
                },
        };
        dispatch(setUserInfoActionCreator(res));
    };
